import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import { useHistory } from "react-router-dom";
import api from '../../services/api_exportadores';
import styles from "./styles.module.css";
import apidesp from '../../services/api_despesas';
import { BsPencilFill } from "react-icons/bs";


export default function Exportadores() {

    const [exportadores, setExportadores] = useState([]);
    const [isControladoria, setIsControladoria] = useState(false);

    useEffect(() => {
        apidesp.get(`/usuario/getPerfilByUser`).then(function (response) {
            if (response.data) {
                if (response.data.usuario_perfil) {
                    response.data.usuario_perfil.forEach((perf, index) => {
                        if (parseInt(perf.perfil_id) === 5) {
                            setIsControladoria(true);
                            return;
                        }

                    })
                }
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });

    }, []);

    useEffect(() => {
        api.get(`/needfilter/${(isControladoria ? 0 : 1)}`).then(function (response) {
            if (response.data) {
                setExportadores(response.data)
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
        });
    }, [isControladoria]);

    let history = useHistory();

    function handleClickExportador(id) {
        history.push(`/rodarexportador?id=${id}`)
    }

    function handleEditarExportador(id){
        history.push(`/novoexportador?id=${id}`)
    }

    function renderRow() {
        return (
            exportadores.map((exportador) => {
                if (isControladoria) {
                    return (
                        <tr>
                            <td
                                onClick={() => handleClickExportador(exportador.id)}
                                className={styles.clickexportador}
                            >
                                {exportador.descricao}
                            </td>
                            <td
                                onClick={() => handleEditarExportador(exportador.id)}
                                className={styles.clickexportador}
                            >
                                <BsPencilFill />
                            </td>
                        </tr>
                    )
                } else {
                    return (
                        <tr>
                            <td
                                onClick={() => handleClickExportador(exportador.id)}
                                className={styles.clickexportador}
                            >
                                {exportador.descricao}
                            </td>
                        </tr>
                    )
                }
            })
        )
    }

    function handleNovoExportador() {
        history.push('/novoexportador')
    }

    function renderCadastrar() {
        if (isControladoria) {
            return (
                <div>
                    <input type="button" value="CADASTRAR NOVOS EXPORTADORES" className='btn btn-primary' onClick={() => handleNovoExportador()} />
                </div>
            )
        } else {
            return (<></>)
        }
    }

    function renderEditar() {
        if (isControladoria) {
            return (
                <th></th>
            )
        } else {
            return (
                <></>
            )
        }
    }

    return (
        <div className="container-lg">
            <Header title="EXPORTADORES CSV" />
            {renderCadastrar()}
            <table className='table table-sm'>
                <thead>
                    <tr>
                        <th>DESCRIÇÃO</th>
                        {renderEditar()}
                    </tr>
                </thead>
                <tbody>
                    {renderRow()}
                </tbody>
            </table>

        </div>
    )
}